"use client";

import { useEffect } from "react";

export function PreviewNotice(props: {
  mode?: string
}) {
  useEffect(() => {
    const exitPreviw = (e: MessageEvent) => {
      if (e.data === "exitPreview") {
        fetch("/preview_disable/api?redirect=0", {
          credentials: "include",
        }).then(() => {
          window.parent?.postMessage("exitPreviewSuccess", process.env.ADMIN_HOST || "*");
        })
      }
    }
    window.addEventListener("message", exitPreviw);
    return () => {
      window.removeEventListener("message", exitPreviw);
    }
  }, []);

  if (props.mode === "IFRAME") {
    return null;
  }

  return (
    <div className="bg-slate-700 p-2 text-white fixed z-20">
      <div className="container mx-auto flex items-center justify-between gap-x-4">
        <div>当前为预览模式</div>
        <a href="/preview_disable/api">
          <button className="rounded border border-black bg-gray-800 px-4 py-2 text-xs hover:bg-black">
            退出
          </button>
        </a>
      </div>
    </div>
  );
}
